import { createSlice } from "@reduxjs/toolkit";

const getInitialState = () => {
  return {}; // Start with an empty object to hold sheets by their IDs.
};

const initialState = getInitialState();

const workbookControlSlice = createSlice({
  name: "workbookcontrols",
  initialState,
  reducers: {
    setSheetControls: (state, action) => {
      const { Sheetid, controls } = action.payload;
      console.log(controls);
      // Ensure there's an object to store controls for the given Sheetid
      if (!state[Sheetid]) {
        state[Sheetid] = {};
      }

      // Merge the incoming controls object with the existing controls for this Sheetid
      state[Sheetid] = {
        ...state[Sheetid],
        ...controls,
      };
    },
    deleteSheetControls: (state, action) => {
      console.log("Initial State:", state);

      // Extract object IDs
      const objectIds = Object.keys(state);
      console.log("Object IDs:", objectIds);

      // Update the state for each object ID
      const updatedState = objectIds.reduce((acc, objectId) => {
        const currentItem = state[objectId];

        // Update the current item ensuring all properties are present
        const updatedItem = {
          ...currentItem,
          activeIndex: [],
          clickedCaption: [],
          clickedValues: {
            barClickedCaption: [],
            stackClickedCaption: [],
          },
          activeBarIndex: [],
          stackActiveIndex: [],
        };

        // Add updated item to the accumulated state
        acc[objectId] = updatedItem;
        return acc;
      }, {});

      console.log("Updated State:", updatedState);

      // Return the updated state
      return updatedState;
    },
  },
});

// Selector to get the value for a given Sheetid and key
export const getSheetControls =
  ({ Sheetid, key }) =>
    (state) => {
      return state.workbookcontrols[Sheetid]?.[key];
    };


export const { setSheetControls, deleteSheetControls } =
  workbookControlSlice.actions;
export default workbookControlSlice.reducer;
